module.exports = __webpack_public_path__ + "public/img/Mengelola Gaji Karyawan dengan Microsoft Excel Untuk Menjadi Staf Personalia.55d6ba57.png";